export const contentFiscalData = {
	fieldName: {
		ncm: "NCM",
		cest: "CEST",
		fiscalProfile: "Perfil fiscal",
		fiscalGroup: "Grupo fiscal",
		fiscalCode: "SKU",
	},
	placeholder: {
		ncm: "Ingrese el NCM",
		cestInput: "CEST",
		cestSelect: "Seleccione el CEST",
		fiscalProfile: "Seleccione el perfil fiscal",
		fiscalGroup: "Seleccione el grupo fiscal",
		fiscalCode: "Ingresar el SKU",
	},
	infoMessageMyTapp:
		"No es posible desactivar esta función mientras 'Sincronizar con My Tapp' esté activa.",
	requiredField: "Campo obligatorio",
	validationMessage: {
		ncm: "NCM debe contener 8 dígitos",
		cest: "El CEST debe contener 7 dígitos",
		fiscalCode: "Si no se llena, el código será generado automáticamente",
		patternFiscalCode: "Solo números, letras, punto y guión",
	},
	infoMessageManualcest: "¿Agregar CEST manual?",
};
